// Deep links from the report upload page to the video explaining how to download a report.
//
// A video record only holds a free-text title and a section, so the canonical (report, app) pair is
// read from the title: one report-type word, one "report" word and the application name, in any
// order, case or separator ("daily_reports_Ninja", "تقرير_يومي_نينجا", "Ninja Monthly Report").
// Titles holding anything else never match, so a video is never mistaken for another one.

const GUIDELINES_PATH = "/auth/guidelines";

const REPORT_BY_MODE = { W: "daily", M: "monthly" };

const REPORT_WORDS = {
  daily: ["daily", "يومي", "اليومي"],
  monthly: ["monthly", "شهري", "الشهري"],
};
const REPORT_NOUNS = ["report", "reports", "تقرير", "تقارير", "التقرير", "التقارير"];

// Section names are matched loosely ("Daily Files", "الملفات الشهرية").
const SECTION_STEMS = { daily: ["daily", "يومي"], monthly: ["monthly", "شهري"] };

const APP_NAMES = {
  hungerstation: ["hungerstation", "هنقرستيشن"],
  jahez: ["jahez", "جاهز"],
  marsool: ["marsool", "mrsool", "مرسول"],
  ninja: ["ninja", "نينجا"],
  keeta: ["keeta", "كيتا"],
  toyou: ["toyou", "تويو"],
};
export const GUIDE_APPS = Object.keys(APP_NAMES);
const appByName = new Map(GUIDE_APPS.flatMap((app) => APP_NAMES[app].map((name) => [name, app])));

const wordsOf = (title) => String(title || "").normalize("NFKC").toLowerCase().split(/[^\p{L}\p{N}]+/u).filter(Boolean);

// { report, app } for a report guide video, null for every other video.
export function guideOfTitle(title) {
  const words = wordsOf(title);
  const reports = Object.keys(REPORT_WORDS).filter((report) => words.some((word) => REPORT_WORDS[report].includes(word)));
  if (reports.length !== 1 || !words.some((word) => REPORT_NOUNS.includes(word))) return null;
  const ignored = [...REPORT_WORDS[reports[0]], ...REPORT_NOUNS];
  // Joined so "Hunger Station" and "To You" read as one name.
  const app = appByName.get(words.filter((word) => !ignored.includes(word)).join(""));
  return app ? { report: reports[0], app } : null;
}

export const guideUrl = (app, mode) => {
  const params = new URLSearchParams({ section: "videos", guideApp: app, guideReport: REPORT_BY_MODE[mode] });
  return `${GUIDELINES_PATH}?${params}`;
};

// The target in a Guidelines URL; anything incomplete or unknown is the plain page.
export function guideFromParams(params) {
  const app = params.get("guideApp");
  const report = params.get("guideReport");
  return GUIDE_APPS.includes(app) && Object.values(REPORT_BY_MODE).includes(report) ? { app, report } : null;
}

export const findGuideVideo = (videos, guide) =>
  videos.find((video) => {
    const found = guideOfTitle(video.title);
    return found?.app === guide.app && found.report === guide.report;
  }) || null;

export const findGuideSection = (sections, guide) =>
  sections.find((section) => {
    const names = `${section.nameEn || ""} ${section.nameAr || ""}`.toLowerCase();
    return SECTION_STEMS[guide.report].some((stem) => names.includes(stem));
  }) || null;
